import React, { useRef } from 'react'

import {
  Button,
  DialogOverlay,
  DialogOverlayActions,
  DialogOverlayFooter,
  Select,
  TextArea,
  Checkbox,
} from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import useHolocaustDialog from './useHolocaustDialog'

export default () => {}

export function NotHolocaustDialog({ message, personId, personName, onSubmitCallback, onCancelCallback }) {
  const { t } = useTranslation()
  const { holocaustDialogState, holocaustDialogActions } = useHolocaustDialog(
    message,
    personId,
    personName,
    onSubmitCallback,
    onCancelCallback,
    false
  )
  const focusElementRef = useRef()

  if (!holocaustDialogState) {
    return null
  }

  return (
    <div>
      <Button onClick={holocaustDialogActions.overlay.handleClick}>Not Holocaust</Button>
      <DialogOverlay
        {...holocaustDialogActions.overlay}
        focusRef={focusElementRef}
        title={`${personName} (${personId}) - ${t('queues.holocaust.notHolocaust', 'Not Holocaust')}`}
      >
        <Select
          label={t('attribution.chooseLabel', 'Choose a Label')}
          options={[
            {
              value: 'Information - Holocaust - not in Yad Vashem',
              label: `${t('information', 'Information')} - ${t('queues.holocaust', 'Holocaust')} - ${t(
                'queues.holocaust.notInYadVashem',
                'not in Yad Vashem'
              )}`,
            },
            {
              value: 'Information - Holocaust Survived',
              label: `${t('information', 'Information')} - ${t('queues.holocaust.survived', 'Holocaust Survived')}`,
            },
            {
              value: 'Information - Not Holocaust',
              label: `${t('information', 'Information')} - ${t('queues.holocaust.notHolocaust', 'Not Holocaust')}`,
            },
            {
              value: 'Information - Holocaust - lacks enough information for a search',
              label: `${t('information', 'Information')} - ${t('queues.holocaust', 'Holocaust')} - ${t(
                'queues.holocaust.lacksEnoughInformation',
                'lacks enough information for a search'
              )}`,
            },
          ]}
          value={holocaustDialogState.labelSelected}
          onChange={(event) => holocaustDialogActions.setLabelSelected(event.target.value)}
        />
        <TextArea
          ref={focusElementRef}
          label={t('reason', 'Reason')}
          value={holocaustDialogState.changeMessage}
          onChange={(event) => holocaustDialogActions.setChangeMessage(event.target.value)}
        />
        <Checkbox
          label="Also Delete Message"
          name="selectDeleteMessage"
          checked={holocaustDialogState.deleteMessage}
          onChange={() => {
            return holocaustDialogActions.setDeleteMessageSelected(!holocaustDialogState.deleteMessage)
          }}
        />

        <DialogOverlayFooter>
          <DialogOverlayActions>
            <Button onClick={() => holocaustDialogActions.onOk()} emphasis="high">
              {t('action.ok', 'OK')}
            </Button>
            <Button onClick={() => holocaustDialogActions.onCancel()} emphasis="medium">
              {t('action.cancel', 'Cancel')}
            </Button>
          </DialogOverlayActions>
        </DialogOverlayFooter>
      </DialogOverlay>
    </div>
  )
}
